/**
 * V2 Users API client
 * Helpers utilitários sobre users (lookup pra fluxos de convite).
 */

import v2Api from './index';

export const usersV2API = {
  /**
   * Lookup mínimo por email. Retorna { exists, user_id?, name? }.
   * Rate limit sensível aplicado no backend (5 req / 15min).
   */
  lookupByEmail: (email) =>
    v2Api.get('/users/lookup-by-email', { params: { email } }),
};

export default usersV2API;
